import { useEffect, useRef } from 'react';

import { useAuth } from '../../contexts/AuthContext';
import { telemetry } from '../../services/telemetry';
import type { BudgetPlan } from '../../types/auth';

/**
 * Keeps Firebase Analytics + Crashlytics in sync with the signed-in user:
 * user id, logged-in flag, and paid (Pro) plan.
 */
export function TelemetrySync() {
  const { user } = useAuth();
  const prevPlanRef = useRef<BudgetPlan | undefined>(undefined);
  const identifiedIdRef = useRef<string | null>(null);

  useEffect(() => {
    void telemetry.bootstrap();
  }, []);

  useEffect(() => {
    if (user) {
      void telemetry.identify(user);
      if (
        prevPlanRef.current !== undefined &&
        prevPlanRef.current !== 'pro' &&
        user.plan === 'pro'
      ) {
        void telemetry.logSubscribePro();
      }
      identifiedIdRef.current = user.id;
      prevPlanRef.current = user.plan;
      return;
    }

    if (identifiedIdRef.current) {
      void telemetry.clearUser();
      identifiedIdRef.current = null;
      prevPlanRef.current = undefined;
    }
  }, [user]);

  return null;
}
